module.exports = __webpack_public_path__ + "img/yale-logo.b2a289a3.png";